import Highcharts from 'highcharts/highstock';
import HighchartsReact from "highcharts-react-official";
import React, {useEffect, useRef, useState} from "react";
import {RecModel} from "app/model/common/recModel";
import {ImplwayService} from "app/services/rp/ImplWayService";
import {HighchartsOptionsUtil} from "app/utils/highchartsOptionsUtil";
import moment from "moment";
import {numberFormatter, parseNumberWithCommaDecimal} from "app/utils/stringUtil";

export default function Re100MarketRec(props: any) {
  const [chartOptions, setChartOptions] = useState<any>();
  const chartComponent = useRef<any>(null);
  const [re100, setRe100] = useState<any>([['20240305', 0],['20240306', 0]]);

  function fetchRE100List() {
    const re100List: RecModel[] = [];
    ImplwayService.getInstance().getRe100().then((result: any) => {
      result.data.forEach((value: any) => {
        re100List.push(RecModel.fromMap(value));
      });
      setRe100(re100List);
    }).catch(() => {
      setRe100(re100List);
    });
  }

  useEffect(() => {
    fetchRE100List()
  }, []);

  const re100Data = re100.map((value:any) => [moment(value.trdYmd,  'YYYYMMDD').unix() * 1000, value.avgPrc]);
  Highcharts.setOptions(HighchartsOptionsUtil.locale.kr.globalOptions);
  useEffect(() => {
    const chartOptions = {
      chart: {
        type: 'line',
        height: props.height ?? 455,
      },
      title: { text: '' },
      time: HighchartsOptionsUtil.locale.kr.time,
      exporting: {enabled: false},
      credits: {enabled: false},
      rangeSelector: {
        x: 15,
        buttons: [
          {
            type: 'day',
            count: 7,
            text: '7일'
          },
          {
            type: 'month',
            count: 1,
            text: '1개월'
          },
          {
            type: 'month',
            count: 3,
            text: '3개월'
          },
          {
            type: 'year',
            count: 1,
            text: '1년'
          },
          {
            type: 'ytd',
            text: ' 올해'
          },
          {
            type: 'all',
            text: '전체'
          }],
        inputEnabled: false
      },
      tooltip: {
        xDateFormat: '%Y년 %b월 %e일',
        headerFormat: '{point.key}<br/>',
        split: false,
        shared: true,
        formatter: function(this:any):any {
          let s = `<div style="text-align: left;"><b>${moment(this.x).format('YYYY년 M월 D일')}</b>`;
          this.points.forEach((item: any) => {
            const isGradient = typeof item.color === 'object';
            const color = isGradient ? item.color.stops[0][1] : item.color;
            s += `<br />`;
            s += `<span style="color:${color};">●</span>&nbsp;`;
            s += `<span style='font-weight:500;'>${item.series.name}:&nbsp;</span>`;
            s += `<span style='font-weight:700;'>${numberFormatter(item.y, 2)}</span> 원/REC`;
          });
          s += `</div>`;
          return s;
        },
        style: {
          fontSize: '14px'
        }
      },
      legend: {
        enabled: true,
        floating: true,
        symbolWidth: 10,
        symbolHeight:10,
        align: 'right',
        verticalAlign: 'top',
        y: -42,
        itemStyle: {
          color: '#555',
          fontSize: '0.75rem'
        },
        itemHoverStyle: {
          color: '#333',
          fontSize: '0.75rem'
        }
      },
      plotOptions: {
        series: {
          shadow: false,
          borderWidth: 0,
          pointPadding: 0,
          borderRadius: 0,
        },
        line: {
          marker: {
            enabled: false // Disabling markers on the line series
          }
        }
      },
      navigator: {
        xAxis: {
          dateTimeLabelFormats: HighchartsOptionsUtil.locale.kr.dateTimeLabelFormats,
          labels: {
            style: {
              color: '#444',
              fontSize: '0.7rem',
            },
          }
        }
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: HighchartsOptionsUtil.locale.kr.dateTimeLabelFormats,
        showFirstLabel: true,
        showLastLabel: true,
        lineColor: '#999',
        lineWidth: 1,
        labels: {
          style: {
            color: '#444',
            fontSize: '0.7rem',
          },
        }
      },
      yAxis: {
        opposite: false,
        showLastLabel: true,
        title: {
          text: '(원/REC)',
          style: {
            color: '#444',
            fontSize: '0.65rem',
          },
          align: 'high',
          rotation: 0,
          offset: 0,
          y: -25,
          x: -5
        },
        min: 0,
        softMax: 10,
        lineColor: '#999',
        lineWidth: 1,
        gridLineColor: '#CCC',
        gridLineWidth: 1,
        gridLineDashStyle: 'ShortDash',
        labels: {
          y: 4,
          distance: 7,
          style: {
            color: '#444',
            fontSize: "0.7rem",
          },
          formatter: function (this: any) {
            return parseNumberWithCommaDecimal(this.value);
          }
        },
      },
      series: [{
        name: '평균가',
        data: re100Data,
        color: '#4F77C8',
        lineWidth: 2
      }],
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              xAxis: {
                labels: {
                  style: {
                    fontSize: '0.5rem',
                  },
                },
              },
              yAxis: [
                {
                  title: {
                    y: -10,
                    style: {
                      fontSize: '0.5rem',
                    },
                  },
                  labels: {
                    style: {
                      fontSize: '0.5rem',
                    },
                  },
                },
              ],
              legend: {
                floating: false,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                y: 0,
                itemStyle: {
                  fontSize: '0.6rem',
                },
              },
              tooltip: {
                style: {
                  fontSize: '0.6rem',
                },
              },
              navigator: {
                xAxis: {
                  labels: {
                    style: {
                      fontSize: '0.5rem',
                    },
                  },
                },
              },
            },
          },
        ],
      },
    };
    setChartOptions(chartOptions);
  }, [re100]);


  return (
    <div id="graph-typeJ" className="chart">
      {chartOptions && (
        <HighchartsReact ref={chartComponent} constructorType={'stockChart'} highcharts={Highcharts} options={chartOptions}/>
      )}
    </div>
  )
}